import { trigger, transition, style, animate } from '@angular/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fdm-buckets',
  templateUrl: './buckets.component.html',
  styleUrls: ['./buckets.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateX(-100%)', opacity: 0, height:0 }),
        animate('0.2s 120ms ease-in-out', style({transform: 'translateX(0%)', opacity:1, height:'100%' }))
      ]),
      transition(':leave', [
        animate('0.2s 120ms ease-in-out', style({transform: 'translateX(-100%)', opacity:0, height:0 }))
      ])
    ])
  ]
})
export class BucketsComponent implements OnInit {

  @Input()
  controller:any = null;

  plugins:any = [];

  activeIndex:any = {};

  ngOnInit() {
    this.plugins = this.controller.getActive(this.controller);
    // console.log ( 'BUCKETS INIT', this.controller, this.plugins );
  }

  getMyIndex ( token:any ) {
    let allActive = -1;
    let myIndex = 0;
    const keys = Object.keys(this.activeIndex);
    if ( this.activeIndex ) {
      keys.forEach ( key => {
        if ( this.activeIndex[key] ) {
          allActive++;  
        }
        if ( token == key ) {
          myIndex = allActive;
        }
      });
    }
    // console.log('#idx', token, allActive, myIndex, keys, this.activeIndex );
    return myIndex;
  }

  isActive( token:any ) {
    this.activeIndex[token] = true;
  }

  isInactive( token:any ) {
    this.activeIndex[token] = false;
  }

}
